import {COLORS} from 'constants/index';
import {Section} from 'templates/reports/query';

export type Result = Record<Region, Record<Metric, Stats>>;

export type Region = 'head' | 'arms' | 'trunk' | 'legs' | 'total';

export const RegionOrder: Region[] = [
	'head', 'arms', 'trunk', 'legs',
];

export const RegionColors: Record<Region, string> = {
	head: COLORS.SALAD80,
	arms: COLORS.INFOGREEN,
	trunk: COLORS.SKYBLUE,
	legs: COLORS.LIGHTPURPLE,
	total: COLORS.GRAY9,
};

export type Metric = 'bone' | 'fat' | 'lean' | 'total';

export type Stats = {
	grams: number
	pct_region: number
	pct_total: number
	pct_ntile?: number
}

export const parseResult = (comp: Section['results'][0]): Result => {
	return JSON.parse(comp.parse) as Result;
};

export const parseResults = (comp: Section): Result[] => {
	return comp.results.map(parseResult);
};
